import { DiscountDetails, Sku } from '@/types';

export const formattedSkuPrice = (sku: Sku, discountAmount?: number) => {
  let calculatedDiscountAmount = Number(sku?.price?.total) - (Number(discountAmount) || 0);
  if (calculatedDiscountAmount < 0) {
    calculatedDiscountAmount = 0;
  }
  const price = discountAmount ? calculatedDiscountAmount : sku?.price?.total || 0;
  return `${sku?.price?.currency} ${(price ?? 0).toFixed(2)}`;
};

export const skuPrice = (sku: Sku, discountAmount?: number | null): number => {
  let calculatedDiscountAmount = Number(sku?.price?.total) - (Number(discountAmount) || 0);
  if (calculatedDiscountAmount < 0) {
    calculatedDiscountAmount = 0;
  }
  return discountAmount ? calculatedDiscountAmount : sku?.price?.total || 0;
};

export const formattedDiscountPrice = (sku: Sku | null, discount: DiscountDetails | undefined) => {
  const discountAmount =
    discount?.type === 'percentage'
      ? (sku?.price?.total ?? 0) * Math.abs(Number(discount?.amount) || 0)
      : Math.abs(Number(discount?.amount) || 0);

  return discountAmount.toFixed(2);
};
